import React, { Fragment, useRef, useState } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import Timeline from "../components/Timeline";
import { npsSubmitApi } from "../utils/api";
import { format } from "date-fns";
import ProductImage from "./ProductImage";
// import { useJitsu } from "@jitsu/react";

const formatMoney = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount)
    ? amount.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : value;
};

const normalizeItemId = (value) =>
  value === null || value === undefined ? null : String(value);

const deliveryStatuses = [
  {
    id: 4,
    status: "Order shipped",
  },
  {
    id: 3,
    status: "In transit",
  },
  {
    id: 2,
    status: "Out for delivery",
  },
  {
    id: 1,
    status: "Delivered",
  },
];

function OrderDetailsPage({ orderDetails, settings }) {
  const OrderDetailsBox = ({ shipment, index }) => {
    const [openScans, setOpenScans] = useState(false);
    const viewDetailsButtonRef = useRef(null);
    const scans = Array.isArray(shipment.scans)
      ? shipment.scans.filter(
          (scan) => scan && typeof scan === "object"
        )
      : [];

    const closeScans = () => {
      setOpenScans(false);
      viewDetailsButtonRef.current?.focus();
    };
    // const { track } = useJitsu();
    const TimelineItem = ({ item, status }) => (
      <div className="relative pl-5 pb-4 last:pb-0">
        <span
          className={`absolute -left-1.5 top-1 w-3 h-3 rounded-full border border-[#16AC37] ${
            status ? "bg-[#16AC37]" : "bg-white"
          }`}
        ></span>
        <p className="text-xs text-[#424A59]">{item.status || item.label}</p>
        {(item.time || item.date) && (
          <p className="text-[11px] text-[#6F7580]">{item.time || item.date}</p>
        )}
      </div>
    );

    return (
      <section className="p-4 bg-white rounded-2xl mb-4 border border-[#EAEAEB] shadow-[0_4px_16px_rgba(21,31,50,0.04)]">
        <div className="flex items-start w-full gap-3">
          <div>
            <p className="text-[10px] font-medium uppercase tracking-wide text-[#858A93]">
              Shipment
            </p>
            <h2 className="text-sm font-semibold text-[#151F32]">
              Package {index}
            </h2>
          </div>
          {!shipment.is_rto &&
            !shipment.is_cancelled &&
            shipment.current_status_desc !== "Order Placed" && (
              <button
                ref={viewDetailsButtonRef}
                className="ml-auto flex items-center text-white pl-3 pr-2 py-1.5 text-[10px] font-medium rounded-lg"
                style={{
                  background: settings["--site-widget-primary-color"],
                }}
                onClick={() => {
                  setOpenScans(true);
                  // track("clicked_on_order_details");
                }}
              >
                View Details <RiArrowRightSLine className="text-lg font-bold" />
              </button>
            )}
        </div>

        <div className="mt-2">
          {shipment.is_rto ? (
            <p className="inline-block text-[11px] font-medium px-2 py-1 rounded-full bg-[#fff5f8] text-[#f1416c]">
              RTO
            </p>
          ) : shipment.is_cancelled ? (
            <p className="inline-block text-[11px] font-medium px-2 py-1 rounded-full bg-[#fff5f8] text-[#f1416c]">
              Cancelled
            </p>
          ) : (
            shipment.current_status_desc && (
              <p
                className="inline-block text-[11px] font-medium px-2 py-1 rounded-full"
                style={{
                  color:
                    shipment.current_status_desc
                      .toLowerCase()
                      .includes("delivered") &&
                    !shipment.current_status_desc.toLowerCase().includes("rto")
                      ? "#16AC37"
                      : settings["--site-widget-primary-color"],
                  background:
                    shipment.current_status_desc
                      .toLowerCase()
                      .includes("delivered") &&
                    !shipment.current_status_desc.toLowerCase().includes("rto")
                      ? "#E8F7EB"
                      : settings["--site-widget-primary-color-50"],
                }}
              >
                {shipment.current_status_desc
                  .toLowerCase()
                  .includes("delivered") &&
                !shipment.current_status_desc.toLowerCase().includes("rto")
                  ? "Delivered"
                  : shipment.current_status_desc}
              </p>
            )
          )}
        </div>

        <div className="mt-4 space-y-3">
          {shipment.items.map((item, i) => {
            const orderItem =
              orderDetails.order_items &&
              orderDetails.order_items.find((oi) => {
                const orderLineItemId = normalizeItemId(
                  oi.line_item_id ?? oi.order_item_id
                );
                const shipmentLineItemId = normalizeItemId(
                  item.line_item_id ?? item.order_item_id
                );
                if (
                  orderLineItemId &&
                  shipmentLineItemId &&
                  orderLineItemId === shipmentLineItemId
                ) {
                  return true;
                }

                const orderSku = oi.sku || oi.product_sku;
                const shipmentSku = item.sku || item.product_sku;
                if (orderSku && shipmentSku && orderSku === shipmentSku) {
                  return true;
                }

                return (
                  oi.variant_name &&
                  item.variant_name &&
                  oi.variant_name === item.variant_name
                );
              });
            const imageUrl =
              (orderItem && orderItem.image_url) || item.image_url || item.image;
            const title = orderItem
              ? orderItem.product_title
              : item.product_name ||
                item.product_title ||
                item.name ||
                item.title;
            const variantOrSku = orderItem
              ? orderItem.variant_name || orderItem.sku || orderItem.product_sku
              : item.variant_name || item.sku || item.product_sku;
            const productPrice =
              orderItem?.product_price ?? item.product_price;
            return (
              <div
                className="flex items-center gap-3 rounded-xl border border-[#EAEAEB] p-2"
                key={item.order_item_id || item.sku || i}
              >
                <ProductImage src={imageUrl} alt={title} size="shipment" />
                <div className="min-w-0 flex-1 text-xs">
                  <p className="truncate text-sm font-medium text-[#151F32]">
                    {title}
                  </p>
                  <p className="mt-1 flex items-center gap-1 text-[11px] text-[#858A93]">
                    <span
                      style={{ maxWidth: "120px" }}
                      className="truncate"
                    >
                      {variantOrSku}
                    </span>
                    <span aria-hidden="true">•</span>
                    <span>Qty {item.quantity}</span>
                  </p>
                  {productPrice != null && (
                    <p className="mt-1 text-xs font-semibold text-[#151F32]">
                      ₹{formatMoney(productPrice)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {(shipment.carrier || shipment.awbno) && (
          <div className="mt-4 grid grid-cols-2 gap-3 rounded-xl bg-[#F7F7F8] p-3">
            {shipment.carrier && (
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-wide text-[#858A93]">
                  Shipped via
                </p>
                <p className="mt-0.5 truncate text-xs font-medium text-[#424A59]">
                  {shipment.carrier}
                </p>
              </div>
            )}
            {shipment.awbno && (
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-wide text-[#858A93]">
                  Tracking number
                </p>
                <p className="mt-0.5 truncate text-xs font-medium text-[#424A59]">
                  {shipment.awbno}
                </p>
              </div>
            )}
          </div>
        )}

        {!shipment.is_cancelled && !shipment.is_rto && (
          <div className="mt-5">
            <h3 className="mb-4 text-xs font-semibold text-[#151F32]">
              Shipment progress
            </h3>
            <div className="ml-1 border-l border-dashed border-[#C8CACE]">
              <TimelineItem
                status={true}
                item={{
                  id: "5",
                  label: "Order Placed",
                  time: format(
                    new Date(orderDetails.order_created_at),
                    "dd MMM yyyy, hh:mm"
                  ),
                }}
              />
              {shipment.shipment_travel_status &&
              shipment.shipment_travel_status !== null
                ? Object.values(shipment.shipment_travel_status).map((item) => {
                    return (
                      <TimelineItem
                        status={item.completed}
                        item={item}
                        key={item.id}
                      />
                    );
                  })
                : deliveryStatuses.map((item) => {
                    return (
                      <TimelineItem item={item} status={false} key={item.id} />
                    );
                  })}
            </div>
          </div>
        )}
        {/* Bottom Modal */}

        {openScans && (
          <Fragment>
            <div className="overlay" onClick={closeScans} />
            <div
              aria-labelledby={`tracking-details-title-${index}`}
              aria-modal="true"
              className="fixed bg-white left-0 right-0 top-40 bottom-0 z-50 overflow-auto animate-slide-in rounded"
              onKeyDown={(event) => {
                if (event.key === "Escape") closeScans();
              }}
              role="dialog"
            >
              <div className="flex items-center p-5">
                <h2
                  className="font-bold text-xs"
                  id={`tracking-details-title-${index}`}
                >
                  Tracking details
                  {shipment.awbno && (
                    <span className="block mt-1 font-normal">
                      AWB #{shipment.awbno}
                    </span>
                  )}
                </h2>
                <button
                  aria-label="Close tracking details"
                  autoFocus
                  className="ml-auto px-2 py-1 text-lg leading-none text-[#424A59]"
                  onClick={closeScans}
                  type="button"
                >
                  &times;
                </button>
              </div>
              <div className="border border-t-[#EAEAEB] border-b-[#EAEAEB] border-x-0">
                {scans.length > 0 ? (
                  scans.map((item, i) => {
                    return (
                      <Timeline item={item} key={item.id || i} status={true} />
                    );
                  })
                ) : (
                  <p className="p-5 text-xs text-center text-[#6F7580]">
                    Tracking updates are not available for this shipment.
                  </p>
                )}
              </div>
            </div>
          </Fragment>
        )}
      </section>
    );
  };

  const [rating, setRating] = useState(0);
  const [writeReview, setWriteReview] = useState(false);
  const [reviewWritten, setReviewWritten] = useState(false);
  const [review, setReview] = useState("");

  const submitNPS = () => {
    setReviewWritten(true);
    npsSubmitApi(settings.merchant.id, orderDetails.order_id, rating, review)
      .then((resp) => {
        console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      {/* Experience  */}
      {orderDetails.show_nps_details && (
        <div className="p-5 pb-0 text-sm mb-4">
          {reviewWritten ? (
            <p className="text-xs font-bold text-[#424A59]">
              Your feedback has been recorded. Thank you :)
            </p>
          ) : writeReview ? (
            <div>
              <div className="flex items-center">
                <div>
                  <p className="text-xs">Rating {rating}/10</p>
                  <p className="text-xs font-medium mt-1">
                    We'd love to know more from you
                  </p>
                </div>
                <button
                  className="ml-auto flex items-center text-white pl-3 pr-2 py-0.5 text-[10px] rounded bg-black"
                  onClick={() => submitNPS()}
                >
                  Submit <RiArrowRightSLine className="text-lg font-bold" />
                </button>
              </div>
              <textarea
                placeholder="Some feedback words here..."
                className="text-[#424A59] font-medium text-[11px] h-16 rounded w-full p-2 mt-4"
                onChange={(e) => setReview(e.target.value)}
              />
            </div>
          ) : (
            // ) : rating > 0 ? (
            //   <div>
            //     <p className="text-[#424A59] text-xs font-bold">
            //       Thank you for your feedback
            //     </p>
            //     <div className="flex justify-between text-xs mt-3">
            //       <p>Rating {rating}/10</p>
            //       <p
            //         className="flex items-center underline cursor-pointer"
            //         onClick={() => setWriteReview(true)}
            //       >
            //         Write a review <AiOutlineRight className="mt-0.5" />{" "}
            //       </p>
            //     </div>
            //   </div>
            <div>
              <p>Rate your experience with us</p>
              <p className="mt-2 text-xs text-red-500 font-bold">Worst :(</p>
              <div className="flex whitespace-nowrap justify-between w-full mt-1">
                {[...Array(10).keys()].map((experience) => {
                  return (
                    <p
                      className="rounded-half cursor-pointer bg-gray-300 w-6 h-6 text-xs text-center py-1 mr-2 text-black"
                      key={experience}
                      style={{
                        background:
                          experience === 0
                            ? "#DD435D66"
                            : experience === 1
                            ? "#DD435D66"
                            : experience === 2
                            ? "#FB8D0C66"
                            : experience === 3
                            ? "#FB8D0C66"
                            : experience === 4
                            ? "#EAC81766"
                            : experience === 5
                            ? "#EAC81766"
                            : experience === 6
                            ? "#ADE28366"
                            : experience === 7
                            ? "#ADE28366"
                            : experience === 8
                            ? "#2AD70E66"
                            : "#2AD70E66",
                      }}
                      onClick={() => {
                        setRating(experience + 1);
                        setWriteReview(true);
                      }}
                    >
                      {experience + 1}
                    </p>
                  );
                })}
              </div>
              <p className="text-right mt-1 text-xs text-green-500 font-bold">
                Best :)
              </p>
            </div>
          )}
        </div>
      )}
      {/* Order Details  */}
      {orderDetails.shipments.map((shipment, index) => {
        return (
          <OrderDetailsBox
            shipment={shipment}
            index={index + 1}
            key={index}
          />
        );
      })}
    </div>
  );
}

export default OrderDetailsPage;
